/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
var LegacyTiersContext = React.createContext(null);
var determineMembershipLevel = function (rewardsAndOffers) {
    var _a, _b;
    var currentTierName = (_b = (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _a === void 0 ? void 0 : _a.currentTierName) === null || _b === void 0 ? void 0 : _b.toUpperCase();
    var tierLevels = {
        MEMBER: 'MEMBER',
        ELITE: 'ELITE',
        VIP: 'VIP',
    };
    return tierLevels[currentTierName] || 'MEMBER';
    // return 'ELITE';
    // return 'VIP';
};
var LegacyTiersProvider = function (_a) {
    var children = _a.children, rewardsAndOffers = _a.rewardsAndOffers;
    var membershipLevel = determineMembershipLevel(rewardsAndOffers);
    return (React.createElement(LegacyTiersContext.Provider, { value: {
            membershipLevel: membershipLevel,
        } }, children));
};
export { LegacyTiersProvider, LegacyTiersContext };
